import { storeGoods, storeDetail } from "@/libs/api.js";
import { mapGetters } from "vuex";
import { types as Home } from "@/store/home";
import { uleUrl } from "@/libs/common";
const getters = mapGetters({
	getAdcode: Home.AD_CODE,
	getMinAdcode: Home.AD_CODE_MIN,
});

export default {
	name: "store",
	components: {},
	data() {
		return {
			bestGoodsData: [],
			goodsList: [],
			loading: false, //数据更新完，loading为false
			finished: false, //数据已全部加载完，finished为true
			pageNum: 1,
			picHeight: 0,
			store: {
				productRate: "", // 产品评分
				serviceRate: "", //服务评分
				logisticsRate: "", //物流评分
				totalRate: "", //总评分
				storeLogo: "", //店铺logo
			},
			getShareId: "",
			store_id: "",
			area: "",
			freshActType: ''
		};
	},
	computed: {
		...getters,
		shopStatus() {
			return Number(this.store.totalRate);
		},
	},
	methods: {
		resizeEvent() {
			this.picHeight = "height:" + (this.$el.clientWidth / 2 - 30) + "px";
		},
		// 商品详情页跳转
		goPage(listId) {
			if (this.$route.query.name) {
				this.$router.push({
					path: `/item/itemPage/${listId}`,
					query: {
						name: this.$route.query.name,
						latng: this.$route.query.latng,
						addr: this.$route.query.addr,
						city: this.$route.query.city,
						module: this.$route.query.module,
						shareId: this.getShareId,
						store_id: this.store_id,
					},
				});
			} else {
				this.$router.push({
					path: `/item/itemPage/${listId}`,
					query: {
						shareId: this.getShareId,
						store_id: this.store_id,
					},
				});
			}
		},
		getBestGoods(storeId) {
			let data = {
				uleStoreIds: storeId,
				sortType: 3, //sortType 1-按收益 2-按价格 3-按销量
				sortOrder: 2, //sortOrder  1-表示倒序 2-表示正序
				pageSize: 3,
				pageIndex: 1,
				clientCallType: "h5",
				subType: 2,
				cateId: "",
				area: this.area,
			};
			storeGoods(data, "jsoncallback").then((res) => {
				if ((res.returnCode === "0000" || res.code === "0000") && res.data.Listings) {
					this.bestGoodsData = res.data.Listings;

					this.bestGoodsData.forEach((item) => {
						if (~item.defImgUrl.indexOf("http://")) {
							item.defImgUrl = item.defImgUrl.replace("http://", "https://");
						}
					});
				} else {
					this.$toast(res.returnMessage);
				}
			});
		},
		onLoad() {
			let data = {
				uleStoreIds: this.storeId,
				sortType: 3, //sortType 1-按收益 2-按价格 3-按销量
				sortOrder: 2, //sortOrder  1-表示倒序 2-表示正序
				pageSize: 10,
				pageIndex: this.pageNum,
				clientCallType: "h5",
				subType: 2,
				cateId: "",
				area: this.area,
			};
			storeGoods(data, "jsoncallback").then((res) => {
				if ((res.returnCode === "0000" || res.code === "0000") && res.data.Listings) {
					this.loading = false;
					this.goodsList = [...this.goodsList, ...res.data.Listings];
					this.goodsList.forEach((item) => {
						if (~item.defImgUrl.indexOf("http://")) {
							item.defImgUrl = item.defImgUrl.replace("http://", "https://");
						}
					});
					let totalCount = res.data.totalCount || 0;
					if (totalCount <= this.pageNum * 10) {
						this.finished = true;
						this.loading = false;
					} else {
						this.pageNum++;
						this.finished = false;
					}
				} else {
					this.$toast(res.returnMessage);
					this.loading = false;
					this.finished = true;
				}
			});
		},
		goCredentialPage () {
			location.href = `https://www.${uleUrl()}/ulewap/store/storeInfo.html?storeId=${this.storeId}`
		},
	},
	created() {
		console.log('this.$route.query====',this.$route.query)
		window.addEventListener("resize", this.resizeEvent, true);
		if (this.$browser().miniprogram) {
			this.area = this.$route.query.adocde || this.getMinAdcode;
		} else {
			this.area = this.getAdcode;
		}
	},
	mounted() {
		this.storeId = this.$route.params.storeId;
		this.getShareId = this.$route.query.shareId || "";
		this.store_id = this.$route.query.store_id || "";
		this.freshActType =
      this.$route.query.freshActType || this.$cookies.get("ispioltCity")
		this.resizeEvent();
		this.getBestGoods(this.storeId);
		this.$once("hook:beforeDestroy", () => {
			window.removeEventListener("resize", this.resizeEvent);
		});
		storeDetail(this.storeId, "jsonApiCallback").then((res) => {
			if (res.returnCode === "0000" || res.code === "0000") {
				this.store = res.data;
				document.title = res.data.storeName;
			} else {
				this.$toast(res.returnMessage);
			}
		});
	},
};
